import React from 'react';
import { Link } from 'react-router-dom';
import { formatCurrency, formatDate } from '../../../lib/utils';
import { CurrencyTypes } from '../../../lib/systemVariables';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import ApplicationStatusTag from '../../commonComponents/shared/ApplicationStatusTag';
import RecipientApplicationsReportModal from './RecipientApplicationsReportModal';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';

export default class ApplicationsTable extends NavigationComponent {
    constructor(props) {
        super(props);

        this.state = {
            showModals: {
                reportModal: false
            }
        }
    }

    render() {
        return (
            <div className="applications-card-container">
                <div className="applications-card card">
                    <div className="applications-card-header flex-justify flex-center">
                        <label className="input-label">Applications</label>
                        <button className="btn btn-flat btn-small" onClick={() => this.toggleModal("reportModal")} disabled={!this.props.applications.length}>
                            <img src={`/images/export-icon.png`} className="icon-left" alt="export-icon" />Export</button>
                        {this.props.allowCreate && this.props.recipientId &&
                            <Link className="btn btn-primary primary"
                                to={`/applications/create-application/${this.props.recipientId}`}>
                                Create
                            </Link>}
                    </div>
                    {this.props.loading ? <LoadingSpinner height="20" /> :
                        (!this.props.applications.length
                            ? <p className="no-applications"><i className="icon-layers" /><span>There are no applications.</span></p>
                            : <div>
                                <div className="applications-list">
                                    {this.props.applications.map(application => {
                                        const selected = this.props.currentApplicationId === application.applicationId;
                                        return <div key={application.applicationId}
                                            className={`application ${selected ? "application-selected" : this.props.editMode ? "application-disabled" : ""}`}
                                            onClick={(!selected && !this.props.editMode) ? this.props.selectApplication.bind(this, application.applicationId) : null}>
                                                {
                                                    application.isBlocked ? (
                                                        <div className="application-grid">
                                                            <p className="small-text">Private application by {application.createdBy}</p>
                                                            <p className="small-text accent-text text-right">{formatDate(application.date)}</p>
                                                        </div>
                                                    ) : (
                                                        <div className="application-grid">
                                                            <p className="small-text">{application.reason || application.campaign}</p>
                                                            <p className="small-text text-right">{application.campaignIndividualCategory || application.campaignList}</p>
                                                            <p className="small-text">{formatCurrency(application.amount, application.currency === CurrencyTypes.Shekel)}</p>
                                                            <p className="history-table-application-tag"><ApplicationStatusTag status={application.status} /></p>
                                                            <p className="small-text accent-text text-right">{formatDate(application.date)}
                                                                {application.checkOrWireDate && <span className="tooltip application-list-tooltip">Check/Wire Date: {formatDate(application.checkOrWireDate)}</span>}
                                                            </p>
                                                        </div>
                                                    )
                                                }
                                        </div>;
                                    })}
                                </div>
                                {this.props.applications.length > 0 && <div className="application-total">
                                    <p className="text-right bold-text">
                                        Total Paid: {this.props.totalPaid || `${this.props.recipientIsIsraeli ? CurrencyTypes.Shekel : CurrencyTypes.Dollar}0`}
                                    </p>
                                </div>}
                            </div>)}
                </div>
                <RecipientApplicationsReportModal
                    getDataForExport={this.props.getRecipientApplicationsForExport.bind(this)}
                    recipientId={this.props.recipientId}
                    recipientName={this.props.recipientName}
                    export={this.props.export}
                    show={this.state.showModals.reportModal}
                    close={() => this.toggleModal("reportModal")}/>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/recipientAccountsComponents/recipientAccountDetails/ApplicationsHistoryTable.jsx